import { UTILITIES, searchParentElements, formatMoney } from 'helpers/utils';
import { API } from 'helpers/api';
import M from 'materialize-css';
import JSONEditor from '@json-editor/json-editor';
import AutoComplete from '../external-modules/auto-complete';

const state = {
    jobs: {},
    newModel: null,
};
const { urlParameters } = UTILITIES;
const AppContainerId = '#warranty_app';

// === QR Helper ============================================

state.attachments = state.attachments || {};
state.attachments.mode = null; // 'computer' || 'phone'

function ensureCommonUtilitiesCss() {
    if (document.getElementById('warranty-common-utils-style')) return;
    const style = document.createElement('style');
    style.id = 'warranty-common-utils-style';
    style.textContent = `
    .hidden{display:none!important;}
    .att-mode-chooser{
      margin:8px 0 12px;
      display:flex; gap:8px; flex-wrap:wrap;
      position:relative; z-index: 2; /* <-- add this */
    }
    .att-mode-chooser .btn{min-width:210px; display:inline-flex!important; align-items:center;}
  `;
    document.head.appendChild(style);
}

function getAttachmentsPanel() {
    return document.querySelector('#add-attachments.card-panel');
}

function getAttachmentFormRoot() {
    if (
        state &&
        state.attachments &&
        state.attachments.form &&
        state.attachments.form.root &&
        state.attachments.form.root.container
    ) {
        return state.attachments.form.root.container;
    } else {
        return null;
    }
}

function getAttachmentFormBody() {
    const root = getAttachmentFormRoot();
    if (!root) return null;
    return root.querySelector(':scope > .card-panel');
}

function ensureQrContainer() {
    var panel = getAttachmentsPanel();
    if (!panel) return null;

    var box = document.getElementById('qr-upload-box');
    if (box) return box;

    box = document.createElement('div');
    box.id = 'qr-upload-box';
    box.className = 'center-align';
    box.style.margin = '12px 0 12px';
    box.innerHTML = [
        '<p id="qr-upload-note" class="grey-text" style="margin:0 0 8px;"></p>',
        // generator button (hidden by default)
        // '<button id="qr-generate-btn" type="button" class="ob__search__btn" style="display:none; margin-bottom:8px;">',
        // '  Generate QR for mobile upload',
        // '</button>',
        '<a id="qr-upload-link" href="#" target="_blank" rel="noopener" style="display:inline-block;">',
        '  <img id="qr-upload-img" alt="Scan to upload warranty images" ',
        '       style="max-width:220px; display:none; cursor:pointer;" />',
        '</a>',
    ].join('');

    // Insert right after the "Attachments" title <h5>
    var header = panel.querySelector('h5');
    if (header && header.parentNode) {
        header.parentNode.insertBefore(box, header.nextSibling);
    } else {
        panel.insertBefore(box, panel.firstChild);
    }

    // Wire up the generator button
    // var genBtn = box.querySelector('#qr-generate-btn');
    // genBtn.onclick = async function () {
    //     try {
    //         genBtn.disabled = true;

    //         var card = document.querySelector('#add-attachments');
    //         if (card && typeof card.attachSpinner === 'function') card.attachSpinner();

    //         // Normal save path (same with warranty.save)
    //         const res = await warranty.save();

    //         if (res && res.error) {
    //             if (typeof toast === 'function') toast('There was an error saving, please check your inputs.', 'red');
    //             genBtn.disabled = false;
    //         } else {
    //             if (typeof toast === 'function') toast('Saved. Generating QR…');
    //         }
    //     } catch (e) {
    //         if (typeof toast === 'function') toast('Unexpected error while saving.', 'red');
    //         genBtn.disabled = false;
    //     } finally {
    //         var card2 = document.querySelector('#add-attachments');
    //         if (card2 && typeof card2.stopSpinner === 'function') card2.stopSpinner();
    //     }
    // };

    return box;
}

function updateQr(warrantyId) {
    var box = ensureQrContainer();
    if (!box) return;

    var img = box.querySelector('#qr-upload-img');
    var note = box.querySelector('#qr-upload-note');
    var link = box.querySelector('#qr-upload-link');
    // var genBtn = box.querySelector('#qr-generate-btn');

    if (warrantyId) {
        img.src = '/customapi/Uploads/WarrantyUploadQr?warrantyId=' + warrantyId;
        img.style.display = 'inline-block';

        // Clickable link that mints a fresh token and redirects (for testing, can be removed after)
        link.href = '/customapi/Uploads/WarrantyUploadLink?warrantyId=' + warrantyId;
        link.style.pointerEvents = 'auto';

        if (note) {
            note.textContent = 'Scan below to attach images from your phone';
            note.appendChild(document.createElement('br'));
            var refreshNote = document.createElement('small');
            refreshNote.textContent =
                'Please refresh the page after successful phone upload to view changes.';
            note.appendChild(refreshNote);
            note.classList.remove('grey-text');
            note.style.display = '';
        }
        // if (genBtn) {
        //     genBtn.style.display = 'none';
        //     genBtn.disabled = false;
        // }
    } else {
        if (img) {
            img.removeAttribute('src');
            img.style.display = 'none';
        }
        if (link) {
            link.removeAttribute('href');
            link.style.pointerEvents = 'none';
        }
        if (note) {
            note.textContent = ''; // replace text with the button
            note.classList.add('grey-text');
            note.style.display = 'none'; // hide the note
        }
        // if (genBtn) {
        //     genBtn.style.display = 'inline-block';
        //     genBtn.disabled = false;
        // }
    }
}

function escapeHtml(str = '') {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function injectAttachmentStyles() {
    if (document.getElementById('warranty-attachment-style')) return;

    const css = `
  .js--image-description{
    display:inline-block;
    min-height:2rem;
    line-height:1.4;
    outline:none;
    white-space:pre-wrap;
    word-break:break-word;
  }
  .js--image-description.is-empty::before{
    content: attr(data-placeholder);
    opacity:.5;
    color: var(--fontSec, #6b7a88);
    pointer-events:none;
  }
  .js--image-description.editing,
  .js--image-description:focus{
    outline: 3px solid rgba(var(--blue-rgb, 0, 98, 155), .35);
    background: var(--solidWhite, #fff);
    border-radius:2px;
  }`;

    const style = document.createElement('style');
    style.id = 'warranty-attachment-style';
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}

function injectEngineNeedsStyles() {
    // 1) Inject CSS once
    if (!document.getElementById('engine-needs-style')) {
        const style = document.createElement('style');
        style.id = 'engine-needs-style';
        style.textContent = `
/* ===== Engine Needs checkbox (big + red) ===== */
div[data-schemapath="root.NeedReplacementEngineShortBlockOrdered"] label {
  font-size: 35px !important;
  font-weight: 900 !important;
  color: #d32f2f !important;
  line-height: 2;
}
/* Enlarge the checkbox itself */
div[data-schemapath="root.NeedReplacementEngineShortBlockOrdered"] input[type="checkbox"] {
  transform: scale(2);
  margin-right: 12px;
}

/* ===== PO Number (center + clean spacing) ===== */
div[data-schemapath="root.PONumber"] { text-align: center; }

/* If your renderer shows a <label> for title, center it */
div[data-schemapath="root.PONumber"] > label {
  display: block;
  font-weight: 600;
  margin: 0 0 14px 0;
  text-align: center;
}

/* If you used description HTML, many renderers wrap it in .grey-text / [data-role="description"] */
div[data-schemapath="root.PONumber"] .grey-text,
div[data-schemapath="root.PONumber"] [data-role="description"] {
  margin-top: 0 !important;       /* kill negative margins */
  margin-bottom: 14px !important; /* space above the input */
  text-align: center;
  font-weight: 600;
}

/* Center and size the input */
div[data-schemapath="root.PONumber"] input[type="text"] {
  max-width: 420px;
  display: block;
  margin: 8px auto 0; /* extra safety gap from label/description */
  text-align: center;
}
    `.trim();
        document.head.appendChild(style);
    }

    // 2) Normalize any inline negative margin the renderer added already
    const badNodes = document.querySelectorAll(
        'div[data-schemapath="root.PONumber"] .grey-text,' +
            'div[data-schemapath="root.PONumber"] [data-role="description"]',
    );
    badNodes.forEach((el) => {
        const mt = el.style && el.style.marginTop ? String(el.style.marginTop) : '';
        if (mt.includes('-')) el.style.marginTop = '0';
    });

    // 3) Watch for future DOM mutations and keep margins sane
    const poRoot = document.querySelector('div[data-schemapath="root.PONumber"]');
    if (poRoot && !poRoot.__poObserver) {
        const obs = new MutationObserver(() => {
            const bads = poRoot.querySelectorAll('.grey-text, [data-role="description"]');
            bads.forEach((el) => {
                const mt = el.style && el.style.marginTop ? String(el.style.marginTop) : '';
                if (mt.includes('-')) el.style.marginTop = '0';
            });
        });
        obs.observe(poRoot, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['style', 'class'],
        });
        poRoot.__poObserver = obs;
    }
}

async function autoEnsureWarrantyIdAndQr() {
    // const genBtn = document.getElementById('qr-generate-btn');
    const card = document.querySelector('#add-attachments');

    try {
        // if (genBtn) genBtn.disabled = true;
        // if (card && typeof card.attachSpinner === 'function') card.attachSpinner(); // spinner doesn't work!

        const res = await warranty.save();

        if (res && !res.error) {
            state.warranty = res;
            if (typeof toast === 'function') toast('Saved. QR generated for mobile upload');

            updateQr(res && res.Id);
        } else {
            if (typeof toast === 'function')
                toast('There was an error saving, please check your inputs.', 'red');
        }
    } catch (e) {
        console.error(e);
        if (typeof toast === 'function') toast('Unexpected error while saving.', 'red');
    } finally {
        if (card && typeof card.stopSpinner === 'function') card.stopSpinner();
        // if (genBtn) genBtn.disabled = false;
    }
}

function setAttachmentMode(mode) {
    state.attachments.mode = mode;

    const root = getAttachmentFormRoot();
    const body = getAttachmentFormBody();
    const qrBox = ensureQrContainer();

    if (root) root.classList.remove('hidden');

    if (body) body.classList.add('hidden');
    if (qrBox) qrBox.classList.add('hidden');

    if (mode === 'computer' && body) body.classList.remove('hidden');
    if (mode === 'phone' && qrBox) {
        qrBox.classList.remove('hidden');
        if (state.warranty && state.warranty.Id) {
            updateQr(state.warranty.Id);
        } else {
            autoEnsureWarrantyIdAndQr();
        }
    }

    const btnComp = document.getElementById('att-mode-computer');
    const btnPhone = document.getElementById('att-mode-phone');
    [btnComp, btnPhone].forEach((b) => b && b.classList.remove('orange'));
    if (mode === 'computer' && btnComp) btnComp.classList.add('orange');
    if (mode === 'phone' && btnPhone) btnPhone.classList.add('orange');
}

function ensureAttachmentModeUI() {
    const panel = getAttachmentsPanel();
    if (!panel) return;

    const qr = ensureQrContainer();

    let chooser = document.getElementById('att-mode-chooser');
    if (!chooser) {
        chooser = document.createElement('div');
        chooser.id = 'att-mode-chooser';
        chooser.className = 'att-mode-chooser';
        chooser.innerHTML = `
          <div class="row center-align" style="margin-top:10px;">
            <button id="att-mode-computer" type="button" class="btn">Upload from Computer</button>
            <button id="att-mode-phone" type="button" class="btn">Upload from Phone</button>
          </div>
        `;

        const root = getAttachmentFormRoot();

        // Insert right after the "Attachments" title <h5>
        var header = panel.querySelector('h5');
        if (header && header.parentNode) {
            header.parentNode.insertBefore(chooser, header.nextSibling);
        } else {
            panel.insertBefore(chooser, panel.firstChild);
        }
    }

    const btnComp = document.getElementById('att-mode-computer');
    const btnPhone = document.getElementById('att-mode-phone');
    if (btnComp) btnComp.onclick = () => setAttachmentMode('computer');
    if (btnPhone) btnPhone.onclick = () => setAttachmentMode('phone');

    // initial state: keep chooser visible; hide QR + body until a choice
    if (!state.attachments.mode) {
        const body = getAttachmentFormBody();
        const qrBox = document.getElementById('qr-upload-box');
        if (body) body.classList.add('hidden');
        if (qrBox) qrBox.classList.add('hidden');
    } else {
        setAttachmentMode(state.attachments.mode);
    }
}

// === QR Helper ============================================

function ensureUrlHasWarrantyId(id) {
    if (!id) return;
    try {
        var u = new URL(window.location.href);
        if (u.searchParams.get('id') !== String(id)) {
            u.searchParams.set('id', id);
            history.replaceState({ warrantyId: id }, '', u.toString());
        }
    } catch (_) {
        // Fallback for very old browsers
        var qs = window.location.search;
        if (/([?&])id=/.test(qs)) {
            qs = qs.replace(/([?&])id=[^&]*/, '$1id=' + encodeURIComponent(id));
        } else {
            qs += (qs ? '&' : '?') + 'id=' + encodeURIComponent(id);
        }
        history.replaceState(
            { warrantyId: id },
            '',
            window.location.pathname + qs + window.location.hash,
        );
    }
}

const createElementFromSelector = (attributeString) => {
    let element = document.createDocumentFragment();
    const selectors = /^([\*|\w|\-]+)?(#[\w|\-]+)?(\.[\w|\-|\.]+)*(\[.+\])*$/g; // eslint-disable-line
    const attributes = selectors.exec(attributeString);
    if (attributes) {
        if (attributes[1]) {
            element = document.createElement(attributes[1]);
        } else element = document.createElement('div');
        if (attributes[2]) {
            element.setAttribute('id', attributes[2].replace('#', ''));
        }
        if (attributes[3]) {
            element.setAttribute('class', attributes[3].replace('.', ' ').trim());
        }
        if (attributes[4]) {
            const dataAtts = attributes[4].split(']');
            Object.keys(dataAtts).forEach((k) => {
                const keyValue = dataAtts[k].split('=');
                element.setAttribute(
                    keyValue[0].replace('[', ''),
                    keyValue[1] ? keyValue[1].replace('"', '').replace("'", '').trim() : '',
                );
            });
        }
    }
    return element;
};

const toast = (message, color = 'green') => {
    if (message) {
        const ToastConfig = { displayLength: 10000, html: message, classes: color };
        M.toast(ToastConfig);
    }
};

const spinner = {
    create: () => {
        document.querySelector('section').appendAfter(createElementFromSelector('#spinner'));
        const element = document.querySelector('#spinner');
        element.innerHTML = `<div style="position:fixed;z-index:11;left:calc(50% - 75px);right:calc(50% - 75px);bottom:calc(50% - 75px);top:calc(50% - 75px);height:150px;width:150px;" class="preloader-wrapper big active"><div class="spinner-layer spinner-blue-only"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div>`;
        element.setAttribute(
            'style',
            'content:"";display:block;background:rgba(255, 255, 255, 0.6);position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10;',
        );
    },
    destroy: () => {
        const element = document.querySelector('#spinner');
        if (element) element.removeSelf();
    },
    on: () => {
        const element = document.querySelector('#spinner');
        if (element) element.classList.remove('hidden');
        else spinner.create();
    },
    off: () => {
        const element = document.querySelector('#spinner');
        if (element) {
            element.classList.add('hidden');
            spinner.destroy();
        }
    },
};

const getSchema = async (code) => {
    let renderObject = {
        addJobs: false,
        addParts: false,
        ajax: true,
        disable_array_add: true,
        disable_properties: true,
        disable_edit_json: true,
        disable_collapse: true,
        iconlib: 'materialicons',
        no_additional_properties: true,
        required_by_default: true,
        refs: {},
        template: 'handlebars',
        theme: 'materialize',
        upload: () => {},
    };
    switch (code) {
        case 'manufacturers':
            renderObject = await API.get('assets/json/manufacturers/manufacturers.json');
            break;
        case 'eligible-manufacturers':
            renderObject.schema = await API.get(
                'assets/json/manufacturers/eligible_manufacturers.json',
            );
            break;
        case 'save-submit':
            renderObject = await API.get('assets/json/shared/save_submit.json');
            break;
        case 'warranty-closed':
            renderObject = await API.get('assets/json/shared/warranty_closed.json');
            break;
        case 'parts-controls':
            renderObject.schema = await API.get('assets/json/shared/parts_controls.json');
            break;
        case 'parts-table':
            renderObject = await API.get('assets/json/shared/parts_table.json');
            break;
        case 'jobs-controls':
            renderObject.schema = await API.get('assets/json/shared/jobs_controls.json');
            break;
        case 'jobs-table':
            renderObject = await API.get('assets/json/shared/jobs_table.json');
            break;
        case 'attachments-controls':
            renderObject.schema = await API.get(
                'assets/json/shared/warranty_attachments_controls.json',
            );
            break;
        case 'attachments-table':
            renderObject = await API.get('assets/json/shared/attachments_table.json');
            break;
        case 'notes-controls':
            renderObject.schema = await API.get('assets/json/shared/notes_controls.json');
            break;
        case 'notes-table':
            renderObject = await API.get('assets/json/shared/notes_table.json');
            break;
        case 'engine-short-block':
            renderObject.schema = await API.get('assets/json/shared/engine_short_block.json');
            break;
        case 1:
        case 11:
        case 14:
        case 22:
        case 37:
        case 38:
        case 50:
        case 57:
        case 52:
        case 58:
        case 59:
        case 60:
        case 61:
        case 62:
        case 63:
            var mfgSetting = await API.warranty.getMFGSetting(code);

            renderObject.schema = await API.get(mfgSetting.SchemaUrl);
            renderObject.addJobs = mfgSetting.EnableJobs;
            renderObject.addParts = mfgSetting.EnableParts;
            break;
        default:
            break;
    }
    return renderObject;
};

const isArray = (input = null) => {
    if (input && Array.isArray(input)) {
        return true;
    }
    return false;
};

const isObject = (input = null) => {
    if (input && typeof input === 'object') {
        return true;
    }
    return false;
};

const isString = (input = null) => {
    if (input && typeof input === 'string') {
        return true;
    }
    return false;
};

const isNumber = (input = null) => {
    if (input === 0 || input) return !Number.isNaN(input);
    return false;
};

const isBoolean = (input = null) => {
    if (input && typeof input === 'boolean') {
        return true;
    }
    return false;
};

const isHTMLTag = (input = null) => {
    if (
        input &&
        input.format &&
        input.format === 'HTMLTag' &&
        input.tag &&
        typeof input === 'object'
    ) {
        return true;
    }
    return false;
};

const is = {
    Array: (input = null) => {
        if (input && Array.isArray(input)) {
            return true;
        }
        return false;
    },

    Object: (input = null) => {
        if (input && typeof input === 'object') {
            return true;
        }
        return false;
    },

    String: (input = null) => {
        if (input && typeof input === 'string') {
            return true;
        }
        return false;
    },

    Number: (input = null) => {
        if (input === 0 || input) return !Number.isNaN(input);
        return false;
    },

    Boolean: (input = null) => {
        if (input && typeof input === 'boolean') {
            return true;
        }
        return false;
    },

    ValidByRegex: (value, type) => {
        if (type === null) {
            return true;
        }
        return regexByType[type].test(value);
    },

    HTMLTag: (input = null) => {
        if (
            input &&
            input.format &&
            input.format === 'HTMLTag' &&
            input.tag &&
            typeof input === 'object'
        ) {
            return true;
        }
        return false;
    },
};

// Pattern: Manufacturer short name - field short name
const regexByType = {
    'DAY-SERIAL': /^(20(18|19|[2-9][0-9]))(0[1-9]|1[012])([0-9]{6})$/g,
};

const HTMLRenderEngine = (renderObject) => {
    let HTMLContent = document.createDocumentFragment();
    if (isArray(renderObject)) {
        for (let i = 0; i < renderObject.length; i++) {
            HTMLContent.appendChild(HTMLRenderEngine(renderObject[i]));
        }
    }
    if (isObject(renderObject)) {
        if (isHTMLTag(renderObject)) {
            HTMLContent = document.createElement(renderObject.tag);
            let attributes = [];
            if (renderObject.options && renderObject.options.inputAttributes) {
                attributes = Object.keys(renderObject.options.inputAttributes);
                for (let i = 0; i < attributes.length; i++) {
                    HTMLContent.setAttribute(
                        attributes[i],
                        renderObject.options.inputAttributes[attributes[i]],
                    );
                }
            }
            if (renderObject.content) {
                for (let i = 0; i < renderObject.content.length; i++) {
                    if (
                        renderObject.content[i].value &&
                        (isString(renderObject.content[i].value) ||
                            isNumber(renderObject.content[i].value) ||
                            isBoolean(renderObject.content[i].value))
                    ) {
                        HTMLContent.innerHTML = renderObject.content[i].value;
                    } else HTMLContent.appendChild(HTMLRenderEngine(renderObject.content[i]));
                }
            }
        } else HTMLContent.appendChild(HTMLRenderEngine(renderObject.content));
    }

    return HTMLContent;
};

const HTMLRenderer = (
    renderObject,
    HTMLContainer = AppContainerId,
    onChangeObjects = [],
    customRender = true,
) => {
    const container = document.querySelector(`${HTMLContainer}`) || null;
    if (!container) {
        console.error(`HTML ID = '${HTMLContainer}' doesn't exist`);
        return;
    }
    if (!renderObject) {
        console.error(`Render Object, ${renderObject}, doesn't exist`);
        return;
    }
    if (customRender) {
        container.innerHTML = ``;
        container.appendChild(HTMLRenderEngine(renderObject.content));
    } else if (onChangeObjects.length > 0) {
        const form = new JSONEditor(container, renderObject);
        for (let i = 0; i < onChangeObjects.length; i++) {
            form.watch(onChangeObjects[i].path, () => {
                const returnValue = {};
                for (let j = 0; j < onChangeObjects[i].returnValues.length; j++) {
                    returnValue[onChangeObjects[i].returnValues[j]] = form
                        .getEditor(onChangeObjects[i].returnValues[j])
                        .getValue();
                }
                onChangeObjects[i].callback(returnValue);
            });
        }
        return form;
    } else {
        const form = new JSONEditor(container, renderObject);
        return form;
    }
};

const appendHTML = (
    renderObject,
    appendContainer,
    HTMLContainer = AppContainerId,
    onChangeObjects = [],
    customRender = true,
) => {
    const container = document.querySelector(`${HTMLContainer}`) || null;
    if (!container) {
        console.error(`HTML ID = '${HTMLContainer}' doesn't exist`);
        return;
    }
    if (!renderObject) {
        console.error(`Render Object, ${renderObject}, doesn't exist`);
        return;
    }
    const child = createElementFromSelector(appendContainer);
    container.appendChild(child);
    if (customRender) child.appendChild(HTMLRenderEngine(renderObject.content));
    else if (onChangeObjects.length > 0) {
        const form = new JSONEditor(child, renderObject);
        for (let i = 0; i < onChangeObjects.length; i++) {
            form.watch(onChangeObjects[i].path, () => {
                const returnValue = {};
                for (let j = 0; j < onChangeObjects[i].returnValues.length; j++) {
                    returnValue[onChangeObjects[i].returnValues[j]] = form
                        .getEditor(onChangeObjects[i].returnValues[j])
                        .getValue();
                }
                onChangeObjects[i].callback(returnValue);
            });
        }
        return form;
    } else {
        const form = new JSONEditor(child, renderObject);
        return form;
    }
};

const warranty = {
    flatten: async (a) => {
        console.log('Flattening warranty data...', a);
        const b = await API.warranty.getEmptyJson(state.warranty.ManufacturerId);
        const c = {};
        Object.keys(b).forEach((j) => {
            Object.keys(a).forEach((k) => {
                if (j && k && j === k) {
                    c[j] = a[j];
                } else if (typeof a !== 'undefined' && a[k]) {
                    Object.keys(a[k]).forEach((l) => {
                        if (j === l) {
                            c[j] = a[k][j];
                        }
                    });
                }
            });
        });
        c.ManufacturerId = state.warranty.ManufacturerId;
        if (state.jobs) {
            c.JobsPerformed = state.jobs.JobsPerformed || [];
        }
        if (state.parts) {
            c.Parts = state.parts.Parts || [];
            c.PartInvoiceNumber = state.parts.form.getEditor('root.PartInvoiceNumber').value;
            c.LaborOnly = state.parts.form.getEditor('root.LaborOnly').value;
        }
        if (state.attachments) {
            c.Attachments = state.attachments.Attachments || [];
        }
        if (state.initialId) {
            c.Id = state.initialId;
        }
        // if (state.engineNeeds.form) {
        //     const ed = state.engineNeeds.form.getEditor('root.NeedReplacementEngineShortBlockOrdered');
        //     if (ed) c.NeedReplacementEngineShortBlockOrdered = !!ed.getValue();
        // } else {
        //     c.NeedReplacementEngineShortBlockOrdered = false;
        // }
        // Safe default
        c.NeedReplacementEngineShortBlockOrdered = false;

        const isMf1 = state.selectedManufacturer.id === 1 || state.warranty.ManufacturerId === 1;

        console.log('isMf1:', isMf1);

        if (isMf1 && state.engineNeeds.form) {
            const ed = state.engineNeeds.form.getEditor(
                'root.NeedReplacementEngineShortBlockOrdered',
            );
            if (ed) {
                const v = ed.getValue();
                // Normalize robustly (handles true/false strings, 1/0, checkbox 'on')
                c.NeedReplacementEngineShortBlockOrdered =
                    v === true || v === 'true' || v === 1 || v === '1' || v === 'on';
            } else {
                // Optional DOM fallback if the editor isn't found
                const dom = document.querySelector(
                    'div[data-schemapath="root.NeedReplacementEngineShortBlockOrdered"] input[type="checkbox"]',
                );
                if (dom) c.NeedReplacementEngineShortBlockOrdered = dom.checked;
            }
            // PO Number
            const poEd =
                state.engineNeeds.form.getEditor('root.PONumber') ||
                state.engineNeeds.form.getEditor('root.PONumber'); // fallback if key differs
            if (poEd) {
                const raw = poEd.getValue();
                const po = raw == null ? '' : String(raw).trim();
                c.PONumber = po.length ? po : null;
            } else {
                c.PONumber = c.PONumber;
            }

            console.debug(
                'EngineNeeds → need:',
                c.NeedReplacementEngineShortBlockOrdered,
                'po:',
                c.PurchaseOrderNumber,
                '(legacy PONumber:',
                c.PONumber,
                ')',
            );
        }
        return c;
    },
    extrude: async () => {
        state.selectedManufacturer = { id: state.warranty.ManufacturerId };
        state.selectedProductCategory = '';
        state.models = await API.warranty.getModels(
            state.selectedManufacturer.id,
            state.selectedProductCategory,
        );
        state.selectedModel = state.models.find((v) => {
            return v.Id === state.warranty.ModelInformationId;
        });
        if (state.selectedModel) {
            state.models = state.models.filter((v) => {
                return v.ProductCategory === state.selectedModel.ProductCategory;
            });
            state.selectedProductCategory = state.selectedModel.ProductCategory || '';
        }
        const extruded = await getSchema(state.warranty.ManufacturerId);
        state.formSchema = extruded;
        await renderJSONForm(extruded);
    },
    save: async () => {
        state.warranty.ManufacturerId =
            state.warranty.ManufacturerId || state.selectedManufacturer.id;
        const flatFile = await warranty.flatten(state.form.root.getValue());
        flatFile.Status = 100;
        const res = await API.warranty.submit(flatFile);
        if (!state.initialId) {
            state.initialId = res.Id;
        }

        ensureUrlHasWarrantyId(res && res.Id);
        updateQr(res && res.Id);

        return res;
    },
    submit: async () => {
        state.warranty.ManufacturerId =
            state.warranty.ManufacturerId || state.selectedManufacturer.id;
        const flatFile = await warranty.flatten(state.form.root.getValue());
        if (state.warranty.Status !== 502) {
            flatFile.Status = 300;
        } else {
            flatFile.Status = state.warranty.Status;
        }
        if (state.selectedManufacturer.requiredFields) {
            const valid = warranty.validate(flatFile);
            if (valid.is) return { error: valid.message };
        }

        const res = await API.warranty.submit(flatFile);

        if (!state.initialId) {
            state.initialId = res.Id;
        }

        ensureUrlHasWarrantyId(res && res.Id);

        return res;
    },
    validate: (submitValue) => {
        const valid = { is: false, message: 'Please complete all highlighted fields' };
        const errors = [];

        // Temporarily remove the invalid class
        document.querySelectorAll('.invalid').forEach((el, idx, arr) => {
            el.classList.remove('invalid');
        });

        // Parse and validate required fields are filled
        const requiredFields = Object.keys(state.selectedManufacturer.requiredFields);
        requiredFields.forEach((k) => {
            const current = state.selectedManufacturer.requiredFields[k];
            switch (current.type) {
                case 'string':
                    if (!isString(submitValue[k]))
                        errors.push({ field: k, message: 'Incorrect Type' });
                    break;
                case 'number':
                    if (!isNumber(submitValue[k]))
                        errors.push({ field: k, message: 'Incorrect Type' });
                    if (current.maxValue && current.maxValue < submitValue[k])
                        errors.push({ field: k, message: 'Number is too big' });
                    if (current.maxValue && current.minValue > submitValue[k])
                        errors.push({ field: k, message: 'Number is too small' });
                    break;
                case 'boolean':
                    if (!isBoolean(submitValue[k]))
                        errors.push({ field: k, message: 'Incorrect Type' });
                    break;
                case 'date':
                default:
                    if (!submitValue[k]) errors.push({ field: k, message: 'Missing Value' });
            }
        });
        // Custom validation fields
        const customValidation = document.querySelectorAll('[validate]');
        customValidation.forEach((k) => {
            let value = k.value.trim();
            let name = k.getAttribute('name').match(/(\w+\b)/g);
            let field = name[name.length - 1];
            if (!is.ValidByRegex(value, k.getAttribute('validate'))) {
                errors.push({ field, message: 'Value is not valid' });
            }
        });
        // If attachments are required, validate
        if (state.selectedManufacturer.attachmentsRequired && !submitValue.Attachments.length) {
            errors.push({ field: 'Attachments', message: 'No Files Attached' });
        }
        // If parts are required, validate
        if (state.selectedManufacturer.partsRequired && !submitValue.Parts.length) {
            errors.push({ field: 'Parts', message: 'No Parts Added' });
        }
        // Parse errors and notify user
        if (errors.length) {
            console.warn(errors);
            errors.forEach((f) => {
                const current = document.querySelector(`[name*="[${f.field}]"]`);
                switch (f.field) {
                    case 'Attachments':
                        document.querySelector('#add-attachments').classList.add('invalid');
                        document.querySelector('#selectfile').addEventListener('click', () => {
                            document.querySelector('#add-attachments').classList.remove('invalid');
                        });
                        break;
                    case 'Parts':
                        document.querySelector('#add-parts').classList.add('invalid');
                        document.querySelector('#part').addEventListener('focus', () => {
                            document.querySelector('#add-parts').classList.remove('invalid');
                        });
                        break;
                    default:
                        if (current) {
                            current.classList.add('invalid');
                            current.addEventListener('focusout', function () {
                                if (this.value) this.classList.remove('invalid');
                            });
                        }
                        break;
                }
            });
            document.querySelector('.invalid').scrollIntoView(false);
            document.querySelector('.invalid').focus();
            valid.is = true;
        }
        return valid;
    },
    view: async () => {
        await warranty.extrude();

        if (state.form != null && state.form.editors != null) {
            Object.keys(state.form.editors).forEach((k) => {
                const name = k.split('.', 3);

                if (name[2] && name[2] !== 'addnote' && name[2] !== 'selectfile') {
                    state.form.getEditor(k).setValue(state.warranty[name[2]]);
                }
            });
        }

        const addJob = document.querySelector('#addJob') || null;
        if (addJob) {
            state.jobs.JobsPerformed = state.warranty.JobsPerformed;
            job.update();
        }
        const addPart = document.querySelector('#addPart') || null;
        if (addPart) {
            state.parts.Parts = state.warranty.Parts;
            state.parts.form.getEditor('root.LaborOnly').setValue(state.warranty.LaborOnly);
            state.parts.form
                .getEditor('root.PartInvoiceNumber')
                .setValue(state.warranty.PartInvoiceNumber);
            part.update();
        }
        const addAttachment = document.querySelector('#uploadfile') || null;
        if (addAttachment) {
            state.attachments.Attachments = state.warranty.Attachments;
            attachment.update();
        }
        spinner.off();
    },
};

const attachment = {
    add: async (value) => {
        const attachmentCard = document.querySelector('#add-attachments');
        attachmentCard.attachSpinner();
        state.attachments.Attachments = state.attachments.Attachments || [];
        if (state.warranty.Id) {
            const res = await API.warranty.addAttachment({
                id: state.warranty.Id,
                description: value.description,
                image: value.image,
            });
            if (res.error) {
                toast(`An error occurred while uploading: ${res.error}`, 'red');
            } else {
                state.attachments.Attachments.push(res);
                toast('File Attached Successfully');
                attachment.update();
            }
        } else {
            const resp = await warranty.save();
            if (resp.error) {
                toast('There was an error saving, please check your inputs.', 'red');
            } else {
                state.warranty = resp;
                attachment.add(value);
            }
        }
        attachmentCard.stopSpinner();
    },
    clear: () => {
        document.querySelector('input[type="file"]').value = '';
    },
    remove: async (value, update = true) => {
        if (!state.warranty.Id) {
            console.warn('warranty not loaded or saved');
        }
    },
    update: async () => {
        state.attachments.Attachments = state.attachments.Attachments || [];
        let html = ``;
        state.attachments.Attachments.forEach((el) => {
            html += attachment.renderRow(el);
        });
        document.querySelector('#attachments').innerHTML =
            state.attachments.Attachments.length === 0
                ? `<div class="list-grid__results__item list-grid__results__item">No files are currently uploaded.</div>`
                : html;

        attachment.bindTableEvents();
    },

    bindTableEvents: () => {
        const descEls = document.querySelectorAll('.js--image-description');

        const saveDesc = async (el) => {
            const id = el.getAttribute('data-id');
            const newText = el.innerText.trim();

            // Find and cache the current item in state for optimistic UI
            const idx = (state.attachments.Attachments || []).findIndex(
                (a) => String(a.Id) === String(id),
            );
            const prev = idx > -1 ? state.attachments.Attachments[idx].Description || '' : '';

            // No-op if unchanged
            if (newText === prev) return;

            // Optimistic update
            if (idx > -1) state.attachments.Attachments[idx].Description = newText;

            try {
                const res = await API.warranty.editAttachmentDescription(id, newText);
                toast('Description saved');
            } catch (e) {
                // Revert on failure
                if (idx > -1) state.attachments.Attachments[idx].Description = prev;
                // Put the old text back in the UI
                el.innerText = prev || '';
                toast('Failed to save description', 'red');
            }
        };

        descEls.forEach((el) => {
            // Show placeholder styling when empty
            const applyPlaceholder = () => {
                if (!el.innerText.trim()) {
                    el.classList.add('is-empty');
                } else {
                    el.classList.remove('is-empty');
                }
            };
            applyPlaceholder();

            el.addEventListener('focus', () => {
                el.classList.add('editing');
            });

            el.addEventListener('blur', async () => {
                el.classList.remove('editing');
                await saveDesc(el);
                // re-apply placeholder if needed
                if (!el.innerText.trim()) el.innerText = '';
                applyPlaceholder();
            });

            el.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    el.blur(); // triggers save
                }
                // Escape cancels changes and restores current state
                if (e.key === 'Escape') {
                    const id = el.getAttribute('data-id');
                    const item = (state.attachments.Attachments || []).find(
                        (a) => String(a.Id) === String(id),
                    );
                    el.innerText = item && item.Description ? item.Description : '';
                    el.blur();
                }
            });

            // Keep placeholder class in sync while typing
            el.addEventListener('input', applyPlaceholder);
        });
    },

    renderRow: (item) => {
        var isImage = item.FileName.match(/\.(jpeg|jpg|gif|png)$/i);
        var isPDF = item.FileName.match(/\.pdf$/i);

        var filePreview = '';
        if (isImage) {
            filePreview = `
      <a href="${item.PathLocation}" target="_blank">
        <img src="${item.PathLocation}" alt="Warranty Image" class="warranty__file__asset warranty__images__asset">
      </a>`;
        } else if (isPDF) {
            filePreview = `<a href="${item.PathLocation}" target="_blank" class="warranty__file__asset warranty__images__asset">📄 View PDF</a>`;
        } else {
            filePreview = `<a href="${item.PathLocation}" target="_blank" class="warranty__file__asset warranty__images__asset">📎 View File</a>`;
        }

        return `<div class="list-grid__results__item list-grid__results__item">
    <div class="list-grid__results__li list-grid__results--center" data-label="Brand">
      ${filePreview}
    </div>

    <div class="list-grid__results__li list-grid__results--flex4" data-label="Notes">
      <label class="warranty__file__notes warranty__images__notes" for="description">
        <div class="warranty__images__notes-header">
          <p class="warranty__images__notes-title"></p>
          <button class="warranty__file__remove js--photos-remove hidden disabled" data-id="${
              item.Id
          }">Remove
            <span class="fas fa-trash-o"></span>
          </button>
        </div>

        <span
          name="description"
          id="description_${item.Id}"
          class="warranty__file__note js--image-description"
          data-id="${item.Id}"
          contenteditable="true"
          data-placeholder="Click here to add a description…"
          spellcheck="true"
        >${escapeHtml(item.Description || '')}</span>
      </label>
    </div>
  </div>`;
    },
    resetForm: () => {
        const selectFile = document.querySelector('#selectfile');
        const uploadFileBtn = document.querySelector('#uploadfile');
        const upload = document.querySelector(' input[type="file"]');
        const desc = document.querySelector('input[name="root[description]"]');
        const preview = state.attachments.form.getEditor('root.upload');

        if (selectFile) {
            selectFile.classList.remove('disabled');
        }
        if (uploadFileBtn) {
            uploadFileBtn.classList.add('disabled');
        }
        if (upload) {
            try {
                upload.files = null;
            } catch (err) {
                console.warn(err);
            }
            if (upload.value) {
                upload.value = '';
            }
        }
        if (desc) {
            desc.value = '';
            desc.dispatchEvent(new CustomEvent('change'));
        }
        if (preview) {
            preview.preview_value = null;
            preview.setValue(null);
            preview.refreshPreview();
        }
    },
};

const attachmentInit = async () => {
    injectAttachmentStyles();
    ensureCommonUtilitiesCss();

    state.warranty = state.warranty || { Attachments: [] };
    state.attachments = state.attachments || { Attachments: [] };
    state.attachments.Attachments = state.warranty.Attachments;

    state.attachments.controls = await getSchema('attachments-controls');
    state.attachments.table = await getSchema('attachments-table');

    state.attachments.form = appendHTML(
        state.attachments.controls,
        '#add-attachments.card-panel',
        AppContainerId,
        [],
        false,
    );

    const fileUpload = document.querySelector('#selectfile') || null;
    const resetFile = document.querySelector('#resetfile') || null;
    const upload = document.querySelector(' input[type="file"]');
    const submitFile = document.querySelector('#uploadfile');
    if (upload) {
        upload.addEventListener('change', () => {
            const fileInput = document.querySelector(' input[type="file"]');
            const uploadBtn = document.querySelector('#uploadfile');
            if (fileInput.value) {
                fileUpload.classList.add('disabled');
            }
            if (uploadBtn) {
                uploadBtn.classList.remove('disabled');
            }
        });
        if (fileUpload) {
            fileUpload.addEventListener('click', () => {
                const fileInput = document.querySelector(' input[type="file"]');
                fileInput.click();
            });
        }
        if (submitFile) {
            submitFile.addEventListener('click', async () => {
                const value = state.attachments.form.getValue();
                const fileInput = document.querySelector(' input[type="file"]');
                if (fileInput && fileInput.files.length) {
                    await attachment.add({
                        description: value.description,
                        image: fileInput.files[0],
                    });
                    attachment.resetForm();
                }
            });
        }
    }

    if (resetFile) {
        resetFile.addEventListener('click', () => {
            attachment.resetForm();
        });
    }
    appendHTML(state.attachments.table, '#attachments-table', '#add-attachments');

    ensureAttachmentModeUI();

    // queueMicrotask(() => setAttachmentMode('computer')); // set default

    requestAnimationFrame(() => updateQr(state.warranty && state.warranty.Id));
};

const engineNeedsInit = async () => {
    injectEngineNeedsStyles();

    state.engineNeeds = state.engineNeeds || {};
    state.engineNeeds.controls = await getSchema('engine-short-block');

    // Create the card immediately after Attachments by appending right after it
    // (render order = attachmentsInit() then engineNeedsInit())
    state.engineNeeds.form = appendHTML(
        state.engineNeeds.controls,
        '#engine-needs.card-panel', // creates <div id="engine-needs" class="card-panel">
        AppContainerId,
        [],
        false,
    );

    // Prefill if viewing an existing warranty
    if (state.warranty && typeof state.warranty.EngineNeeds !== 'undefined') {
        try {
            state.engineNeeds.form
                .getEditor('root.EngineNeeds')
                .setValue(!!state.warranty.EngineNeeds);
        } catch (e) {
            /* noop */
        }
    }
};

const note = {
    add: async (value) => {
        // document.querySelector('#warranty_app').attachSpinner()
        state.notes.Notes = state.notes.Notes || [];
        if (state.warranty.Id) {
            const res = await API.warranty.addNote(state.warranty.Id, value);
            if (res.error) {
                toast(`An error occurred while adding Note: ${res.error}`, 'red');
            } else {
                state.notes.Notes = res;
                toast('Message Added Successfully');
                note.update();
            }
        } else {
            const resp = await warranty.save();
            if (resp.error) {
                toast('There was an error saving, please check your inputs.', 'red');
            } else {
                state.warranty = resp;
                note.add(value);
            }
        }
    },
    update: async () => {
        state.notes.Notes = state.notes.Notes || [];
        let html = ``;
        state.notes.Notes.forEach((el) => {
            html += el.IsPd ? note.renderPDRow(el) : note.renderUserRow(el);
        });
        document.querySelector('#notes').innerHTML =
            state.notes.Notes.length === 0
                ? `<li class="list-grid__results__item list-grid__results__item">No Messages..</li>`
                : html;
    },
    bindTableEvents: () => {},

    renderPDRow: (item) => {
        return `<li style="max-width:95%;background-color:white;">
    <div class="warranty__messages__message ">
      <div class="warranty__messages__logo">
        <img src="/assets/warranty-message-pd.png" alt="" class="warranty__messages__asset">
      </div>
      <div class="warranty__messages__response-wrapper">
        <div class="warranty__messages__response">
          <p>${item.Note}</p>
        </div>
        <p class="warranty__messages__date"><span class="warranty__messages--bold">${item.TimeStamp} - ${item.CreatedBy}</p>
      </div>
    </div>
  </li>`;
    },
    renderUserRow: (item) => {
        return `<li style="max-width:95%;background-color:white;">
    <div class="warranty__messages__message warranty__messages--user">
      <div class="warranty__messages__logo">
        <span class="fas fa-user-circle-o warranty__messages__asset"></span>
      </div>
      <div class="warranty__messages__response-wrapper">
        <div class="warranty__messages__response">
          <p>${item.Note}</p>
        </div>
        <p class="warranty__messages__date"><span class="warranty__messages--bold">${item.TimeStamp}</p>
      </div>
    </div>
  </li>`;
    },
};

const noteInit = async () => {
    state.warranty = state.warranty || { Notes: [] };
    state.notes = state.notes || { Notes: [] };
    state.notes.Notes = state.warranty.Notes;
    state.notes.controls = await getSchema('notes-controls');
    state.notes.table = await getSchema('notes-table');
    state.notes.form = appendHTML(
        state.notes.controls,
        '#add-notes.card-panel',
        AppContainerId,
        [],
        false,
    );

    const submitNote = document.querySelector('#uploadfile');

    appendHTML(state.notes.table, '#notes-table', '#add-notes');

    const addNote = document.querySelector('#addNote');
    if (addNote) {
        addNote.addEventListener('click', async () => {
            const noteContent = document.querySelector('#Note');
            if (noteContent && noteContent.value && noteContent.value.trim()) {
                await note.add(noteContent.value.trim());
                noteContent.value = '';
            }
        });
    }
};

const part = {
    add: async (value) => {
        const addparts = document.querySelector('#add-parts');
        addparts.attachSpinner();
        state.parts.Parts = state.parts.Parts || [];
        if (state.warranty.Id) {
            if (value.Quantity > 0) {
                const res = await API.warranty.addLaborPart(
                    state.warranty.Id,
                    value.Id,
                    value.Quantity,
                );
                if (res.error) {
                    toast(`An error occurred while adding Parts: ${res.error}`, 'red');
                } else {
                    state.parts.Parts = res.data;
                    state.parts.PartsTotal = res.PartsTotal;
                    part.update();
                }
            }
        } else {
            const resp = await warranty.save();
            if (resp.error) {
                toast('There was an error saving, please check your inputs.', 'red');
            } else {
                state.warranty = resp;
                part.add(value);
            }
        }
        addparts.stopSpinner();
    },
    clear: () => {
        document.querySelector('input[name="root[Quantity]"]').value = '';
        document.querySelector('input[name="root[PartNumber]"]').value = '';
        document.querySelector('input[name="root[Id]"]').value = '';
    },
    remove: async (value, update = true) => {
        state.parts.Parts = state.parts.Parts || [];
        const res = await API.warranty.removeLaborPart(state.warranty.Id, value.Id);
        if (res.error) return;
        state.parts.Parts = state.parts.Parts || [];
        state.parts.Parts = res.data;
        state.parts.PartsTotal = res.PartsTotal;
        if (update) part.update();
    },
    removeAll: async () => {
        state.parts.Parts = state.parts.Parts || [];
        const temp = state.parts.Parts;
        for (let i = 0; i < temp.length; i++) {
            await part.remove(temp[i], false); // eslint-disable-line
        }
        part.update();
    },
    consolidate: (value) => {
        state.parts.Parts = state.parts.Parts || [];
        for (let i = 0; i < state.parts.Parts.length; i++) {
            if (state.parts.Parts[i].Id === value.Id) {
                state.parts.Parts[i].Quantity += value.Quantity;
                return;
            }
        }
    },
    update: async () => {
        let html = ``;
        state.parts.Parts = state.parts.Parts || [];
        state.parts.PartsTotal = state.parts.PartsTotal || parseFloat('0');
        for (let i = 0; i < state.parts.Parts.length; i++) {
            html += `<li>
      <div class="js--line-item ob__results__item" data-line-item="${state.parts.Parts[i].Id}">
        <div class="ob__results__li" data-label="Part #">${state.parts.Parts[i].PartNumber}</div>
        <div class="ob__results__li ob--tc" data-label="Qty.">
          <p class="ob--center" type="text" data-id="${state.parts.Parts[i].Id}">${
              state.parts.Parts[i].Quantity
          }</p>
        </div>
        <div class="ob__results__li ob__results--flex3 ob--justify-start" data-label="Description">
            <p class="ob__results__text">${state.parts.Parts[i].PartDescription}</p>
        </div>
        <div class="ob__results__li" data-label="Cost">${formatMoney(
            parseFloat(state.parts.Parts[i].DollarAmount),
        )}</div>
        <div class="ob__results__li" data-label="Total">${formatMoney(
            parseFloat(state.parts.Parts[i].TotalReimbursement),
        )}</div>
        <button class="ob__results__remove ob__overview__clear js--part-remove" data-id="${
            state.parts.Parts[i].Id
        }">
          <i class="fas fa-times-circle" aria-hidden="true"></i>
        </button>
      </div>
    </li>`;
        }
        document.querySelector('#parts').innerHTML =
            state.parts.Parts.length === 0
                ? '<li class="js--ob-no-items ob__results__no-items"><div class="ob__results__item"><p class="js--no-items">No parts have been selected.</p></div></li>'
                : html;
        document.querySelector('#parts-total').innerHTML = state.parts.PartsTotal;
        document.querySelectorAll('.js--part-remove').forEach((k) => {
            k.addEventListener('click', (e) => {
                const value = { Id: searchParentElements(e.target, { type: 'data-id' }) };
                part.remove(value);
            });
        });
    },
};

const partInit = async () => {
    state.warranty = state.warranty || { Parts: [] };
    state.parts = state.parts || { Parts: [] };
    state.parts.Parts = state.warranty.Parts;
    state.parts.controls = await getSchema('parts-controls');
    if (state.selectedManufacturer.id === 14) {
        state.parts.controls.schema.title = 'Parts';
    }

    state.parts.table = await getSchema('parts-table');
    state.parts.form = appendHTML(
        state.parts.controls,
        '#add-parts.card-panel',
        AppContainerId,
        [],
        false,
    );
    const autocomplete = new AutoComplete({
        selector: 'input[name="root[PartNumber]"]',
        minChars: 2,
        source: async (term, res) => {
            const mans = state.selectedManufacturer.mfcodes;
            const prods = await API.product.autocomplete(term, mans);
            res(prods);
        },
        renderItem: (item, search) => {
            return `
      <div class="js--ob-sc ob__searchcard autocomplete-suggestion" data-val="${item.Product.ManufacturerCode}, ${item.Product.PartNumber}" data-part="${item.Product.Id}" data-description="${item.Product.Description}" data-cost="${item.Product.ActualCost}">
        <p class="ob__searchcard__title">
        <span>${item.Product.ManufacturerCode},</span>
        <span class="ob__searchcard__focus">${item.Product.PartNumber}</span></p>
        <p class="ob__searchcard__description">${item.Product.Description}</p>
      </div>`;
        },
        onSelect: async (e, term, item) => {
            document.querySelector('input[name="root[Id]"]').value = item.getAttribute('data-part');
            if (document.querySelector('input[name="root[Id]"]').dispatchEvent) {
                document
                    .querySelector('input[name="root[Id]"]')
                    .dispatchEvent(new CustomEvent('change'));
            }
        },
    });
    appendHTML(state.parts.table, '#parts-table', '#add-parts');
    const addPart = document.querySelector('#addPart') || null;
    if (addPart) {
        addPart.addEventListener('click', () => {
            const value = state.parts.form.getValue();
            if (value.Quantity > 0 && value.Id) {
                part.add(value).then(() => {
                    part.clear();
                    toast(`Part Added`);
                });
            } else {
                toast(`Select a part or provide a quantity that is greater than 0`, 'red');
            }
        });
    }
    Object.keys(state.parts.form.editors).forEach((k) => {
        if (k.split('.').length === 2) {
            if (state.parts.form.editors[k].value) {
                state.parts.form.editors[k].label.classList.add('active');
            }
        }
        if (state.parts.form.editors[k].format === 'textarea')
            state.parts.form.editors[k].label.classList.add('active');
    });
};

const job = {
    add: async (value) => {
        const addjobs = document.querySelector('#add-jobs');
        addjobs.attachSpinner();
        state.jobs.JobsPerformed = state.jobs.JobsPerformed || [];
        if (state.warranty.Id) {
            const res = await API.warranty.addJob(
                state.warranty.Id,
                state.selectedModel.Id,
                value.Id,
            );
            if (res.error) {
                toast(`An error occurred while adding the Job: ${res.error}`, 'red');
            } else {
                state.jobs.JobsPerformed = res.data;
                state.jobs.LaborTotal = res.LaborTotal;
                job.update();
            }
        } else {
            const resp = await warranty.save();
            if (resp.error) {
                toast('There was an error saving, please check your inputs.', 'red');
            } else {
                state.warranty = resp;
                job.add(value);
            }
        }
        addjobs.stopSpinner();
    },
    remove: async (value, update = true) => {
        state.jobs.JobsPerformed = state.jobs.JobsPerformed || [];
        const res = await API.warranty.removeJob(state.warranty.Id, value.Id);
        if (res.error) return;
        state.jobs.JobsPerformed = res.data;
        state.jobs.LaborTotal = res.LaborTotal;
        if (update) job.update();
    },
    removeAll: async () => {
        state.jobs.JobsPerformed = state.jobs.JobsPerformed || [];
        const temp = state.jobs.JobsPerformed;
        for (let i = 0; i < temp.length; i++) {
            await job.remove(temp[i], false); // eslint-disable-line
        }
        await job.update();
    },

    updateList: (model) => {
        if (!state.formSchema.addJobs) {
            return;
        }
        // document.querySelector('#add-jobs.card-panel').removeAllChildrenHTML()
        if (state.jobs.form) {
            state.jobs.form.destroy();
        }
        if (document.querySelector('#jobs-table')) {
            document.querySelector('#jobs-table').remove();
        }
        for (let i = 0; i < state.models.length; i++) {
            if (parseInt(state.models[i].Id, 10) === parseInt(model, 10)) {
                state.selectedModel = state.models[i];
                break;
            }
        }
        if (state.selectedModel.Jobs.length) {
            for (let i = 0; i < state.selectedModel.Jobs.length; i++) {
                state.jobs.controls.schema.definitions.Jobs.enumSource[0].source[i] = {
                    Id: state.selectedModel.Jobs[i].Id,
                    Name: state.selectedModel.Jobs[i].Description,
                };
            }

            state.jobs.form = appendHTML(
                state.jobs.controls,
                '',
                '#add-jobs.card-panel',
                [],
                false,
            );

            appendHTML(state.jobs.table, '#jobs-table', '#add-jobs.card-panel');
            const addJob = document.querySelector('#addJob') || null;
            if (addJob) {
                addJob.addEventListener('click', () => {
                    for (let i = 1; i < state.selectedModel.Jobs.length; i++) {
                        if (
                            parseInt(state.jobs.form.getEditor('root.Id').getValue(), 10) ===
                            state.selectedModel.Jobs[i].Id
                        ) {
                            state.jobs.form
                                .getEditor('root.Name')
                                .setValue(state.selectedModel.Jobs[i].Description);
                        }
                    }
                    job.add(state.jobs.form.getValue());
                });
            }
            document.querySelector('#add-jobs.card-panel').classList.remove('hide');
        } else {
            const jobscard = document.querySelector('#add-jobs.card-panel');
            if (jobscard) {
                jobscard.classList.add('hide');
            }
            return;
        }
        Object.keys(state.jobs.form.editors).forEach((k) => {
            if (k.split('.').length === 2) {
                if (state.jobs.form.editors[k].value && state.jobs.form.editors[k].label) {
                    state.jobs.form.editors[k].label.classList.add('active');
                }
            }
            if (
                state.jobs.form.editors[k].format === 'textarea' &&
                state.jobs.form.editors[k].label
            )
                state.jobs.form.editors[k].label.classList.add('active');
        });
        document.querySelector('.js--jobs-clear').addEventListener('click', () => {
            job.removeAll();
        });
    },
    update: async () => {
        let html = ``;
        state.jobs.JobsPerformed = state.jobs.JobsPerformed || [];
        state.jobs.LaborTotal = state.jobs.LaborTotal || 0;
        for (let i = 0; i < state.jobs.JobsPerformed.length; i++) {
            html += `<li>
      <div class="ob__results__item">
        <div class="ob__results__li ob__results--flex3 ob--justify-start" data-label="Name">${state.jobs.JobsPerformed[i].Description}</div>
        <div class="ob__results__li" data-label="Time">${state.jobs.JobsPerformed[i].Minutes}</div>
        <button class="ob__results__remove ob__overview__clear js--job-remove" data-id="${state.jobs.JobsPerformed[i].Id}">
          <i class="fas fa-times-circle" aria-hidden="true"></i>
        </button>
      </div>
    </li>`;
        }
        if (document.querySelector('#jobs')) {
            document.querySelector('#jobs').innerHTML =
                state.jobs.JobsPerformed.length === 0
                    ? '<li class="ob__results__no-items"><div class="ob__results__item"><p>No Jobs have been Selected.</p></div></li>'
                    : html;
            document.querySelector('#jobs-total').innerHTML = state.jobs.LaborTotal;
            document.querySelectorAll('.js--job-remove').forEach((k) => {
                k.addEventListener('click', (e) => {
                    const selectedJob = { Id: searchParentElements(e.target, { type: 'data-id' }) };
                    job.remove(selectedJob);
                });
            });
        }
    },
};

const jobInit = async () => {
    state.warranty = state.warranty || { JobsPerformed: [] };
    state.jobs = state.jobs || {};
    state.jobs.JobsPerformed = state.warranty.JobsPerformed || [];
    state.jobs.controls = await getSchema('jobs-controls');
    state.jobs.table = await getSchema('jobs-table');
    state.jobs.form = appendHTML(
        state.jobs.controls,
        '#add-jobs.card-panel',
        AppContainerId,
        [],
        false,
    );
    appendHTML(state.jobs.table, '#jobs-table', '#add-jobs');
    const addJob = document.querySelector('#addJob') || null;
    if (addJob) {
        addJob.addEventListener('click', () => {
            job.add(state.jobs.form.getValue());
        });
    }
    Object.keys(state.jobs.form.editors).forEach((k) => {
        if (k.split('.').length === 2) {
            if (state.jobs.form.editors[k].value && state.jobs.form.editors[k].label) {
                state.jobs.form.editors[k].label.classList.add('active');
            }
        }
        if (state.jobs.form.editors[k].format === 'textarea' && state.jobs.form.editors[k].label)
            state.jobs.form.editors[k].label.classList.add('active');
    });
};

const populateDropdowns = async (definitions = null) => {
    state.options = await API.warranty.getOptionFields();
    state.models =
        state.models ||
        (await API.warranty.getModels(
            state.selectedManufacturer.id,
            state.selectedProductCategory,
        ));
    if (definitions) {
        Object.keys(definitions).forEach((k) => {
            if (state.options[k]) {
                definitions[k].enumSource[0].source = definitions[k].enumSource[0].source.concat(
                    state.options[k],
                );
            }
            if (k === 'Models') {
                definitions[k].enumSource[0].source = definitions[k].enumSource[0].source.concat(
                    state.models,
                );
            }
        });
    }
    return definitions;
};

const renderJSONForm = async (renderObject = null) => {
    let introObject = {};
    const onChangeObjects = [];
    let model = 0;

    if (!state.manufacturers) {
        const res = await getSchema('manufacturers');

        state.manufacturers = res.manufacturers;
    }

    for (let i = 0; i < state.manufacturers.length; i++) {
        if (
            state.manufacturers[i].id === state.selectedManufacturer.id &&
            state.manufacturers[i].instructions &&
            state.manufacturers[i].instructions[
                `${state.selectedManufacturer.id}_${state.selectedProductCategory}`
            ]
        ) {
            state.selectedManufacturer = state.manufacturers[i];

            introObject =
                state.manufacturers[i].instructions[
                    `${state.selectedManufacturer.id}_${state.selectedProductCategory}`
                ];
        }
    }

    if (
        state.selectedManufacturer != null &&
        (state.selectedManufacturer.id === 1 || state.selectedManufacturer.code === 'BS')
    ) {
        // Handle redirecting to new warranty form for Briggs & Stratton (only if no warrantyId or warrantyId >= 300000)
        const warrantyId = getWarrantyId();
        if (warrantyId != null) {
            if (warrantyId >= 300000) {
                // Redirect to new form
                window.location.href = '/warranty-form/?code=BS&id=' + warrantyId;
                return;
            }
        } else {
            window.location.href = '/warranty-form/?code=BS';

            return;
        }
    }

    if (!renderObject) {
        renderObject = await getSchema(state.selectedManufacturer.id);

        state.formSchema = renderObject;
    }

    renderObject.schema.definitions = await populateDropdowns(renderObject.schema.definitions);

    const { addJobs, addParts } = renderObject;

    HTMLRenderer(introObject, AppContainerId);

    state.form = appendHTML(renderObject, '#warranty-form', AppContainerId, onChangeObjects, false);

    state.form.on('ready', () => {
        const elems = document.querySelectorAll('.datepicker');
        const options = {
            autoClose: true,
            format: 'mm/dd/yyyy',
            onSelect: () => {
                const datepicker = document.querySelectorAll('.datepicker.invalid');
                datepicker.forEach((k) => {
                    k.dispatchEvent(new CustomEvent('focusout'));
                });
            },
        };

        M.Datepicker.init(elems, options);

        state.form.on('change', () => {
            const invalidFields = [];

            if (state.form.editors != null) {
                Object.keys(state.form.editors).forEach((k) => {
                    const name = k.split('.');
                    if (name.length === 3) {
                        if (state.form.editors[k].value && state.form.editors[k].label) {
                            state.form.editors[k].label.classList.add('active');
                        }
                        if (state.form.editors[k].value) {
                            if (state.form.editors[k].path.toLowerCase().includes('date')) {
                                const newVal = new Date(state.form.editors[k].value);
                                if (newVal.toString() === 'Invalid Date') {
                                    toast('Invalid date format', 'orange');
                                    state.form.editors[k].input.value = '';
                                    invalidFields.push(state.form.editors[k].formname);
                                } else if (newVal.getFullYear() < 1971) {
                                    toast('Invalid date entered', 'orange');
                                    state.form.editors[k].input.value = '';
                                    invalidFields.push(state.form.editors[k].formname);
                                } else if (
                                    state.form.editors[k].input.value !==
                                    newVal.getMonth() +
                                        1 +
                                        '/' +
                                        newVal.getDate() +
                                        '/' +
                                        newVal.getFullYear()
                                ) {
                                    state.form.editors[k].input.value =
                                        newVal.getMonth() +
                                        1 +
                                        '/' +
                                        newVal.getDate() +
                                        '/' +
                                        newVal.getFullYear();
                                    // state.warranty[name[2]] = state.form.editors[k].value
                                    invalidFields.push(state.form.editors[k].formname);
                                }
                            } else {
                                // state.warranty[name[2]] = state.form.editors[k].value
                            }
                        }
                    }

                    if (state.form.editors[k] && state.form.editors[k].format === 'textarea')
                        state.form.editors[k].label.classList.add('active');
                });
            }

            if (invalidFields.length) {
                invalidFields.forEach((el, idx) => {
                    const found = document.getElementsByName(el);
                    if (found.length) {
                        found[0].dispatchEvent(new CustomEvent('change'));
                    }
                });
            }
        });
        // state.form.watch('root.product.ModelInformationId', async () => {
        //     model = state.form.getEditor('root.product.ModelInformationId').getValue();
        //     await job.removeAll();
        //     job.updateList(model);
        // });

        state.form.watch('root.product.ModelInformationId', async () => {
            model = parseInt(state.form.getEditor('root.product.ModelInformationId').getValue());
            job.updateList(model);
            if (model != null && state.newModel != null && model != state.newModel) {
                await job.removeAll();
            }
            state.newModel = model;
        });

        const bools = document.querySelectorAll('[data-schematype="boolean"]');
        if (bools && bools.length) {
            document.querySelectorAll('[data-schematype="boolean"]').forEach((el) => {
                el.classList.add('left-align');
            });
        }

        // Autofill Owner's Information button from current user
        var button = state.form.root.getButton('Click Here If Dealer Stock', 'edit', '');
        button.value = '1';
        button.classList.remove('btn');
        button.classList.remove('waves-effect');
        button.classList.remove('waves-light');
        button.setAttribute(
            'style',
            'display:block;position:absolute;top:0px;left:0px;margin-left:0.75rem;padding:0.75rem 1.5rem;background:#ea7200;color:#fff;font-family:"ProximaNova-Bold";font-size:16px;text-align:center;-webkit-transition: all 0.2s ease;transition: all 0.2s ease;',
        );
        button.querySelector('i').style.display = 'none';
        var ownerform = state.form.getEditor('root.owner');
        try {
            state.form
                .getEditor('root.owner')
                .header.parentNode.parentNode.insertBefore(
                    button,
                    state.form.getEditor('root.owner').header.parentNode.nextSibling,
                );
        } catch (error) {}

        button.addEventListener('mouseenter', (event) => {
            event.target.style.background = '#b75900';
        });
        button.addEventListener('mouseleave', (event) => {
            event.target.style.background = '#ea7200';
        });
        button.addEventListener('click', function (e) {
            API.address.get().then((res) => {
                if (res) {
                    var add = res.Address;
                    state.form.getEditor('root.owner.OwnerAddress').setValue(add.StreetLine1);
                    state.form.getEditor('root.owner.OwnerCity').setValue(add.City);
                    state.form.getEditor('root.owner.OwnerName').setValue(add.Name);
                    state.form.getEditor('root.owner.OwnerPhone').setValue(add.Phone);
                    state.form.getEditor('root.owner.OwnerState').setValue(add.State);
                    state.form.getEditor('root.owner.OwnerZip').setValue(add.Zip);
                }
            });
        });
    });

    await attachmentInit();

    if (state.selectedManufacturer.id == 1) {
        await engineNeedsInit();

        // Restore DB value to checkbox after init
        const ed = state.engineNeeds.form.getEditor('root.NeedReplacementEngineShortBlockOrdered');
        if (ed && state.warranty) {
            const v = state.warranty.NeedReplacementEngineShortBlockOrdered;
            const val = v === true || v === 'true' || v === 1 || v === '1';
            ed.setValue(val);
        }

        // After the form/editor is created
        const poEd = state.engineNeeds.form.getEditor('root.PONumber');
        if (poEd && state.warranty) {
            // Be defensive: DB might store PO as number/null/empty
            const dbPo = state.warranty.PONumber;
            poEd.setValue(dbPo == null ? '' : String(dbPo));
        }
    }

    if (addParts) {
        await partInit();
        document.querySelector('.js--parts-clear').addEventListener('click', () => {
            part.removeAll();
        });
    }

    if (addJobs) {
        await jobInit();
    }
    if (state.warranty.Id && state.warranty.Status > 100) {
        await noteInit();
        await note.update();
    }

    if (state.warranty && state.warranty.IsOpen === false) {
        state.actions = await getSchema('warranty-closed');
    } else {
        state.actions = await getSchema('save-submit');
    }

    appendHTML(state.actions, '#action-buttons.card-panel', AppContainerId);

    const save = document.querySelector('#save') || null;
    const submit = document.querySelector('#submit') || null;

    if (save) {
        save.addEventListener('click', async () => {
            const warrantysave = document.querySelector('#warranty_app');
            warrantysave.attachSpinner();
            const res = await warranty.save();
            if (res.error) {
                toast(`An error occurred while Saving: ${res.error}`, 'red');
            } else {
                toast(`Saved Successfully`);
            }
            warrantysave.stopSpinner();
        });
    }

    if (submit) {
        submit.addEventListener('click', async () => {
            const warrantysubmit = document.querySelector('#warranty_app');
            warrantysubmit.attachSpinner();
            const res = await warranty.submit();
            console.log('Submit Response:', res);
            if (res.error) {
                if (res.error.response.data.Message) {
                    toast(`ERROR - ${res.error.response.data.Message}`, 'red');
                    warrantysubmit.stopSpinner();
                } else {
                    toast(`An error occurred while Submitting: ${res.error}`, 'red');
                    warrantysubmit.stopSpinner();
                }
            } else if (
                !!state.selectedManufacturer.statusMessage &&
                !!state.selectedManufacturer.statusMessage[res.Status.toString()]
            ) {
                const msgConfig = state.selectedManufacturer.statusMessage[res.Status.toString()];
                toast(msgConfig.content, msgConfig.color);
                window.setTimeout(function () {
                    window.location.assign('view-all-warranties');
                }, 5000);
            } else {
                toast(`Submitted Successfully`);
                window.setTimeout(function () {
                    window.location.assign('view-all-warranties');
                }, 5000);
            }
        });
    }
};

const getProductCategory = async (res) => {
    const manufacturerCode = res['root.manufacturers'];
    let renderObject = {};
    const appendContainerID = '#product_buttons';
    const onChangeObjects = [];
    state.selectedManufacturer = {};
    state.selectedManufacturer.id = parseInt(manufacturerCode, 10);

    if (!state.manufacturers) {
        const res = await getSchema('manufacturers');
        state.manufacturers = res.manufacturers;
    }
    for (let i = 0; i < state.manufacturers.length; i++) {
        if (state.manufacturers[i].id === state.selectedManufacturer.id) {
            renderObject = state.manufacturers[i];
            onChangeObjects.push(state.manufacturers[i].onChange);
        }
    }
    const container = document.querySelector(appendContainerID);
    if (container) container.removeSelf();
    appendHTML(renderObject, appendContainerID, AppContainerId, onChangeObjects);

    const btns = document.querySelectorAll('#product-button');
    if (btns.length) {
        for (let i = 0; i < btns.length; i++) {
            btns[i].addEventListener('click', (e) => {
                state.selectedProductCategory =
                    searchParentElements(e.target, { type: 'data-product' }) || '';
                console.log(`Product Category is set to: ${state.selectedProductCategory}`);
                renderJSONForm();
            });
        }
    }
};

const eligibleManufacturers = async () => {
    state.eligibleManufacturers = await API.warranty.getEligibleManufacturers();
    const renderObject = await getSchema('eligible-manufacturers');
    for (let i = 0; i < state.eligibleManufacturers.length; i++) {
        renderObject.schema.definitions.select_manufacturer.enumSource[0].source.push({
            title: `${state.eligibleManufacturers[i].Description}`,
            value: state.eligibleManufacturers[i].Id,
        });
    }
    const onChangeObjects = [
        {
            callback: getProductCategory,
            path: 'root.manufacturers',
            returnValues: ['root.manufacturers'],
        },
    ];
    state.eligibleManufacturerForm = HTMLRenderer(
        renderObject,
        AppContainerId,
        onChangeObjects,
        false,
    );
};

const getWarrantyId = () => {
    if (urlParameters != null) {
        if (
            urlParameters.id != null &&
            typeof urlParameters.id === 'object' &&
            urlParameters.id.length > 0
        ) {
            const warrantyId = Number(urlParameters.id[0]);
            if (!isNaN(warrantyId)) {
                return warrantyId;
            }
        }
    }

    return null;
};

async function init() {
    if (urlParameters.id) {
        const warrantyapp = document.querySelector('.dashboard__modules-wrapper');

        warrantyapp.attachSpinner({ overlay: false, left: '50%', top: '50%' });

        state.warranty = await API.warranty.getWarranty(urlParameters.id);
        state.initialId = urlParameters.id[0]; // eslint-disable-line

        await warranty.view();

        updateQr(state.warranty && state.warranty.Id);

        if (document.querySelector('#parts-total')) {
            document.querySelector('#parts-total').innerHTML = state.warranty.PartsTotal;
        }
        if (document.querySelector('#jobs-total')) {
            document.querySelector('#jobs-total').innerHTML = state.warranty.JobsTotal;
        }
        if (state.warranty.Status >= 300) {
            if (document.querySelector('#submit')) {
                document.querySelector('#submit').innerHTML = 'Save Changes';
            }
            if (document.querySelector('#save')) {
                document.querySelector('#save').classList.add('hide');
            }
        }

        // if (document.querySelector('div[data-schemapath="root.owner"]')) {
        //   var ownerSection = document.querySelector('div[data-schemapath="root.owner"]')
        //   var html = ownerSection.innerHTML
        //   var button = `<button>Click Me</button>`
        //   ownerSection.innerHTML = button + html;
        // }

        var path = 'root.PartNumber';

        // Do not sanitize messages, they are encoded on the backend
        if (state.notes && state.notes.form) {
            state.notes.form.getEditor(path).sanitize = function (value) {
                return (value || '').replace('#', '').replace('&', '');
            };
        }

        warrantyapp.stopSpinner();

        return;
    }

    await eligibleManufacturers();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/warranty-app.js